module.exports = __webpack_public_path__ + "static/media/D.52fea94e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/D.svg
// module id = 168
// module chunks = 0